import React from 'react';
import OTPModal from '../MyProfile/OTPModal';

interface IsaTransferOtpModalProps {
    isOpen: boolean;
    isLoading?: boolean;
    isSendingOtp?: boolean;
    onRetrySend?: () => Promise<void>;
    errorMessage?: string | null;
    onClose: () => void;
    onContinue: (otp: string, otpMode: string) => Promise<{ success: boolean; errorType?: string }>;
    verificationToken: string;
}

const IsaTransferOtpModal: React.FC<IsaTransferOtpModalProps> = ({
    isOpen,
    isLoading = false,
    isSendingOtp = false,
    onRetrySend,
    errorMessage,
    onClose,
    onContinue,
    verificationToken
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <OTPModal
            title="Transferring your ISA"
            mobileNumber=""
            verificationToken={verificationToken}
            customVerification={async (otp, otpMode) => {
                const result = await onContinue(otp, otpMode);
                return {
                    success: result.success,
                    data: { approved: result.success },
                    message: result.success ? undefined : result.errorType === 'unexpected' ? 'UnexpectedError' : 'VerifyingOtpError'
                };
            }}
            onClose={onClose}
            onComplete={onClose}
            analyticsRegion="ISA Transfer"
            analyticsAction="ISA Transfer"
            noNumberMessage
            isSendingOtp={isSendingOtp}
            onRetrySend={onRetrySend}
            errorMessage={!verificationToken ? errorMessage ?? undefined : undefined}
            hideClose={isLoading || isSendingOtp}
        />
    );
};

export default IsaTransferOtpModal;
